import { sizeVariantValues } from "@insite/mobius/FormField/formStyles";

sizeVariantValues.default = {
    fontSize: 16,
    height: 40,
    icon: 18,
    iconPadding: 10,
    descriptionLineSpacing: 10,
    borderRadius: 7,
    datePickerWidth: 145,
    leftLabelPadding: 9,
    button: "medium",
    labelHeight: 32,
};
